import Attendance from "../../models/Attendance";


export const parseAttendanceResponse = (responseData) => {
  const attendances = [];

  for (const cedula in responseData) {
    const registros = responseData[cedula];
    for (const item of registros) {
      attendances.push(
        new Attendance({
          ...item,
          cedula: cedula,
        })
      );
    }
  }

  return attendances;
}
